import React from "react";
import "./ViewTruckModal.scss";

import editIcon from "../../../../../../Assets/images/edit-icon.svg";
import closeIcon from "../../../../../../Assets/images/close-icon.svg";
import downloadiconGrey from "../../../../../../Assets/images/downloadicon-normal.png";
import downloadiconGreen from "../../../../../../Assets/images/downloadicon-active.png";

import moment from "moment";
import { saveAs } from "file-saver";

import { DATE_FORMAT, TRUCK_DOCS_DOWNLOAD_PATH } from '../../../Utils/Constants';
import { showErrorToast } from "../../../../../../Context/Toaster/Toaster";
import { hasPermission } from "../../../Services/permission";

const TRUCK_SECTION = "Trucks";
const TRUCK_EDIT_KEY = ["trucks_edit"];

const ViewTruckModal = ({ truck, onClose, onEdit }) => {
    if (!truck) return null;

    const getDocUrl = (docName) => {
        if (!docName) return null;
        return `${TRUCK_DOCS_DOWNLOAD_PATH}/${encodeURIComponent(docName)}`;
    };

    const handleDownload = async (fileUrl, fileName) => {
        if (!fileUrl) {
            showErrorToast("No file available to download.");
            return;
        }

        try {
            const response = await fetch(fileUrl);
            if (!response.ok) {
                showErrorToast("No file available to download.");
                return;
            }

            const blob = await response.blob();
            if (!blob || blob.size === 0 || blob.type === "text/html") {
                showErrorToast("No file available to download.");
                return;
            }

            saveAs(blob, fileName || "document");
        } catch (err) {
            showErrorToast("Failed to download file.");
        }
    };

    const canEditTrucks = hasPermission({ section: TRUCK_SECTION, keys: TRUCK_EDIT_KEY });
    

    return (
        <div className="modal right rtm-modal fade show d-block" tabIndex="-1" role="dialog" style={{ backgroundColor: "rgba(0,0,0,0.15)" }}>
            <div className="modal-dialog rtl-dialog">
                <div className="modal-content rtl-content animate__animated animate__fadeInRight rtl-overflow">
                    <div className="ajob-content">
                        <div className="cpf-top cpf-border">
                            <h2>Truck Details</h2>
                            <div className="d-flex align-items-center">
                                {
                                    canEditTrucks && (
                                        <div className="driver-edit edt-icn" onClick={(e) => { e.preventDefault(); onEdit && onEdit(truck); onClose(); }}>
                                            <img src={editIcon} alt="edit" />
                                        </div>
                                    )
                                }
                                <button className="m-close" onClick={onClose}>
                                    <img src={closeIcon} alt="Close" />
                                </button>
                            </div>
                        </div>

                        <div className="modal-inner addtruck-form">
                            <div className="adddriver-form scroll-padding">
                                <div className="row">
                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Truck ID</label>
                                            <div>T-{truck.truck_id || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Vehicle Number</label>
                                            <div>{truck.vehicle_no || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Permit (MTO Permit)</label>
                                            <div>{truck.permit_no || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">License Plate Number</label>
                                            <div>{truck.license_plate_no || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Truck Type</label>
                                            <div>{truck.truck_type || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Insurance Number</label>
                                            <div>{truck.insurance_no || "-"}</div>
                                        </div>
                                    </div>

                                    <div className="col-md-6">
                                        <div className="cp-split">
                                            <label className="fi-label driver-lbl">Last Updated On</label>
                                            <div>
                                                {truck.last_upated_datetime
                                                    ? moment(truck.last_upated_datetime).local().format(DATE_FORMAT)
                                                    : "-"}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="doc-cover">
                                    <h2 className="sub-head">Documents</h2>
                                    <div className="row">
                                        {[
                                            { label: "CVOR", doc: truck.cvor_doc, expiryLabel: "CVOR Expiry", expiry: truck.cvor_expiry },
                                            { label: "Permit Document", doc: truck.permit_doc, expiryLabel: "Permit Expiry", expiry: truck.permit_expiry },
                                            { label: "Insurance", doc: truck.insurance_doc, expiryLabel: "Insurance Expiry", expiry: truck.insurance_expiry },
                                            { label: "Emission", doc: truck.emission_doc, expiryLabel: "Emission Expiry", expiry: truck.emission_expiry }
                                        ].map((d, i) => (
                                            <React.Fragment key={i}>
                                                <div className="col-md-6" key={i}>
                                                    <div className="cp-split">
                                                        <label className="fi-label driver-lbl">{d.label}</label>
                                                        <div className="doc-value">
                                                            {d.doc ? (
                                                                <div className="doc-wraper" onClick={() => handleDownload(getDocUrl(d.doc), d.doc)} >
                                                                    <div className="dlicon-cover">
                                                                        <img className="download-image" src={downloadiconGrey} alt="download" />
                                                                    </div>
                                                                    <span className="doc-name">{d.doc}</span>
                                                                </div>
                                                            ) : "-"}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="col-md-6">
                                                    <div className="cp-split">
                                                        <label className="fi-label driver-lbl">{d.expiryLabel}</label>
                                                        <div className="truckexpiry-value">
                                                            {d.expiry
                                                                ? moment(d.expiry).format(DATE_FORMAT)
                                                                : "-"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </React.Fragment>
                                        ))}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ViewTruckModal;